(function ($) {
  $(document).ready(function () {

    $('.home-collections [data-home-collections-slider]').each(function () {
      var $slider = $(this);

      var startX = 0, startY = 0;
      var moved = false;         // 是否发生了滑动
      var threshold = 10;        // 判定为“滑动”的像素阈值（可调大一点更安全）

      // 记录起点（按下/触摸开始）
      $slider.on('touchstart mousedown', 'a', function (e) {
        moved = false;

        var oe = e.originalEvent;
        var p = (oe.touches && oe.touches[0]) ? oe.touches[0] : e;

        startX = p.pageX;
        startY = p.pageY;
      });

      // 只要移动超过阈值，就认为是“滑动”
      $slider.on('touchmove mousemove', function (e) {
        var oe = e.originalEvent;
        var p = (oe.touches && oe.touches[0]) ? oe.touches[0] : e;

        if (!p || p.pageX == null) return;

        var dx = Math.abs(p.pageX - startX);
        var dy = Math.abs(p.pageY - startY);

        if (dx > threshold || dy > threshold) moved = true;
      });

      // 如果发生了滑动：阻止 a 跳转
      $slider.on('click', 'a', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      });

      // slick 的 swipe 事件：更稳（如果主题有 slick）
      $slider.on('swipe', function () {
        moved = true;
      });

      // 松手后稍微延迟复位，避免 iOS 触发“补一刀 click”
      $slider.on('touchend mouseup', function () {
        setTimeout(function () { moved = false; }, 50);
      });

    });

  });
})(jQuery);
